import { PointExpirePopupWidgetStyled } from './styled';
import { useTheme } from 'styled-components';
import { RenderCommaMoney } from 'utils/functions/formatMoney';
import { Buttons, Icons } from 'components';

// Popup แจ้งเตือนคะแนนสะสมใกล้หมดอายุ
// data = object จาก GET /point-expire/me (period, expiring_point, days_left)
const PointExpirePopupWidget = ({ data, onClose, onRedeem }) => {
  const theme = useTheme();
  const period = data?.period || {};
  const expiringPoint = data?.expiring_point || 0;
  const daysLeft = data?.days_left;

  return (
    <PointExpirePopupWidgetStyled>
      <div className="popup_bg" onClick={onClose} />
      <div className="popup_card">
        <div className="popup_close" onClick={onClose}>
          <Icons.CloseX color="red" />
        </div>
        <div className="pe_logo_wrap">
          <img
            className="pe_logo"
            alt="misumi logo"
            src="/assets/images/logos/logo.png"
          />
        </div>
        <div className="pe_warning_bar">
          <span className="pe_warning_icon">!</span>
        </div>
        <div className="pe_title">แจ้งเตือนคะแนนสะสมใกล้หมดอายุ!</div>
        <div className="pe_desc">
          {`คะแนนสะสมที่ได้รับระหว่างวันที่ ${period.received_label || '-'} จะหมดอายุในวันที่ ${period.expire_label || '-'} นี้`}
          <br />
          กรุณาใช้สิทธิ์แลกของรางวัลก่อนวันหมดอายุค่ะ
        </div>
        <div className="pe_highlight">
          <div className="pe_highlight_label">คะแนนที่จะหมดอายุ</div>
          <div className="pe_highlight_point">
            <span className="pe_point_number">
              {RenderCommaMoney(expiringPoint)}
            </span>
            <span className="pe_point_unit">คะแนน</span>
          </div>
          {typeof daysLeft === 'number' && daysLeft >= 0 && (
            <div className="pe_highlight_days">
              {daysLeft === 0 ? 'หมดอายุวันนี้' : `เหลืออีก ${daysLeft} วัน`}
            </div>
          )}
        </div>
        <div className="pe_btn_wrap">
          <div className="pe_btn_item">
            <Buttons.BgStandard
              theme_stadard_btn
              bgColor={theme.COLORS.BLUE_2}
              txtColor={theme.COLORS.WHITE_1}
              label="แลกของรางวัล"
              onClick={onRedeem}
            />
          </div>
          <div className="pe_btn_item">
            <Buttons.BgStandard
              theme_cancel_btn
              label="ปิด"
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </PointExpirePopupWidgetStyled>
  );
};

export default PointExpirePopupWidget;
